export default "__VITE_PUBLIC_ASSET__841faa49__"